// extracted by mini-css-extract-plugin
module.exports = {"table":"VotingTable_table__1LztL","table__head":"VotingTable_table__head__2QbNt","table__item":"VotingTable_table__item__2rU6z"};